import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { setOnboardingConfig } from '#queries/set-onboarding-config.ts';
import { useOnboardingModuleConfig } from '#components/onboarding-module-config-context.ts';

interface UseSetOnboardingProps {
  showOnboarding: boolean;
}

export const useSetOnboardingConfig = ({
  showOnboarding,
}: UseSetOnboardingProps) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { onOnboardingComplete } = useOnboardingModuleConfig();

  return useMutation(() => setOnboardingConfig({ showOnboarding }), {
    onSettled: () => {
      queryClient.invalidateQueries(['get_show_onboarding']);
      if (onOnboardingComplete) {
        onOnboardingComplete();
      } else {
        // to ensure we trigger the redirect logic in root app for b2b
        // please keep path to be / instead of /member
        navigate('/');
      }
    },
  });
};
